import { BoxProps, Box } from '@material-ui/core';

export type DSBoxProps = BoxProps;

export const DSBox = Box;
